import { Injectable } from '@angular/core';
import { DataService } from 'src/app/shared/session';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AccesoReporteService {

    constructor(private dataService: DataService) { }

    private saveAccesoReporteUrl: string = 'accesoReporte/save';

    guardarAccesoReporte(idNivelAcceso: number, idEntidad: number, idRol: number, idReporte: number): any {
        let parameters: string;
        parameters = JSON.stringify({
            idNivelAcceso: idNivelAcceso,
            idEntidad: idEntidad,
            idRol: idRol,
            idReporte: idReporte,
        });
        this.dataService._baseUri = environment.serviceCreditosUrl + this.saveAccesoReporteUrl;
        return this.dataService.execPostJson(parameters);
    }
}